import React from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import TablePagination from "components/Molecules/TablePagination"
import AddButton from "components/Templates/AddButton"
import DateSelector from "components/Templates/DateSelector"
import ModuleHeader, { Description } from "components/Templates/ModuleHeader"
import { useSearchFilter } from "hooks/searchFilterHooks"
import { OPEN_DISPATCH_DRAWER, RESET_STATE } from "store/dispatch.redux"

const DispatchTableHeader = () => {
  const [{ search, date, page }, setFilter] = useSearchFilter()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  return (
    <ModuleHeader
      white={true}
      borderBottom="none"
      header={<Description icon="send-to" title="Dispatches" />}
      query={search}
      onQueryChange={query => {
        setFilter(prev => ({
          ...prev,
          search: query,
          page: 0,
        }))
      }}
    >
      <TablePagination
        className="mr-3"
        page={page}
        onPageChange={page => {
          setFilter(prev => ({
            ...prev,
            page,
          }))
        }}
      />
      <DateSelector
        value={date}
        onChange={(_, date) => {
          setFilter(prev => ({
            ...prev,
            date,
          }))
        }}
      />
      <AddButton
        onClick={e => {
          navigate("/d/ecom/dispatch/add")
          dispatch({
            type: RESET_STATE,
          })
          dispatch({
            type: OPEN_DISPATCH_DRAWER,
          })
        }}
        text="Dispatch"
      />
    </ModuleHeader>
  )
}

export default DispatchTableHeader
